import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-go-back-button',
  templateUrl: './go-back-button.component.html',
  styleUrls: ['./go-back-button.component.css']
})
export class GoBackButtonComponent implements OnInit {

  @Output() goBackBtnClicked = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  goBack() {
    this.goBackBtnClicked.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/go-back-button/go-back-button.component.ts